import { Injectable } from '@angular/core'
import { AlertController } from 'ionic-angular'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'

import { activeStorageHost } from '../config'
import { Store } from '@ngrx/store'
import { AppState } from '../reducers'


import { DirectUpload, DirectUploadDelegate } from '@rails/activestorage'
import { CompleteDirectUpload, ErrorDirectUpload, InitDirectUpload, ProgressDirectUpload, StartDirectUpload } from '../actions/direct-upload'

@Injectable()
export class DirectUploadApi {
  protected urlBase: string

  constructor(
    private store: Store<AppState>,
  ) {
    this.urlBase = `${activeStorageHost()}/direct_uploads`
    this.store.dispatch(new InitDirectUpload())
  }

  uploadFile(file: File):Observable<ActiveStorage.Blob> {
    let directUpload = new DirectUpload(file, this.urlBase, {
      directUploadWillStoreFileWithXHR: request => {
        request.upload.addEventListener('progress',
          event => this.store.dispatch(new ProgressDirectUpload( (event.loaded / event.total) * 100) )
        )
      }
    })
    return new Observable<ActiveStorage.Blob>(observer => {
      this.store.dispatch(new StartDirectUpload())
      directUpload.create((error, blob) => {
        if (error) {
          this.store.dispatch(new ErrorDirectUpload(`[${error.name}] ${error.message}`))
          observer.error(error)
        } else {
          this.store.dispatch(new CompleteDirectUpload(blob))
          observer.next(blob)
        }
        observer.complete()
      })
      return {unsubscribe() {}}
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/direct-upload.ts